import { getData, postData, putData, deleteData } from '../FetchApiServices';

const BASE = 't2t/saved-views';

export const fetchSavedViews        = ()               => getData(`${BASE}`);
export const fetchSavedViewById     = (id)             => getData(`${BASE}/${id}`);
export const createSavedView        = (body)           => postData(`${BASE}`, body);
export const updateSavedView        = (id, body)       => putData(`${BASE}/${id}`, body);
export const deleteSavedView        = (id)             => deleteData(`${BASE}/${id}`);
export const duplicateSavedView     = (id)             => postData(`${BASE}/${id}/duplicate`, {});
export const shareSavedView         = (id, body)       => postData(`${BASE}/${id}/share`, body);
export const unshareSavedView       = (id, shareId)    => deleteData(`${BASE}/${id}/shares/${shareId}`);
export const togglePinSavedView     = (id)             => putData(`${BASE}/${id}/pin`, {});
export const setDefaultSavedView    = (id)             => putData(`${BASE}/${id}/default`, {});
export const fetchViewPreferences   = ()               => getData(`${BASE}/preferences`);
export const upsertViewPreferences  = (body)           => putData(`${BASE}/preferences`, body);
